import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function SelectFromArray(props) {
  return (
    <FormControl
      variant="standard"
      sx={{ m: 1, minWidth: 160 }}
      className="selectFromA extraSmall"
    >
      <InputLabel id="selectLabel">{props.label}</InputLabel>
      <Select
        // label={props.label}
        labelId="selectLabel"
        // id="termsMenu"
        name={props.name}
        value={props.val[props.name]}
        // onChange={(e) => props.setVal(e.target.value)}
        onChange={(e) => props.setVal(e)}
      >
        {props.optionsA.map((item) => {
          return (
            <MenuItem value={item.val} key={item.val}>
              {item.ttl}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
